import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import idSelector from './id-selector'
import template from './id-select-filter.hbs'
import SingleSelectFormView from 'scoreboard/components/single-select-form-view'

var IdSelectFilter = Backbone.View.extend({

	_template: template,

	initialize: function(options) {
		this.options = _.defaults(options, {multiple: true})
		this.data = _.assign({values:[], metadata: {}}, this.options.data)
		this.selectionData = options.seedData || []
		this.selectionMap = _.keyBy(this.selectionData, 'id')
		this.formViewType = SingleSelectFormView
	},

	render: function () {
		var content = $(this._template(this.options))

		var select = content.find('select')
		idSelector(select, this.selectionData, this.data.metadata, this.options)

		this.$el.html(content)

		return this
	},

	//returns the data captured by this filter
	gather: function(e) {
		this.data.values = []
		_.forEach(this.$('select').val(), function(id) {
			this.data.values.push(parseInt(id))
			this.data.metadata[id] = this.selectionMap[id]
		}.bind(this))
		return this.data
	}

})

export default IdSelectFilter

IdSelectFilter.__filename__ = 'reports/wizard/filter-meta/id-select-filter.js'
